<template>
  <div
    class="container-fluid"
    style="
      background-image: url('./Image/back.jpg');
      background-size: cover;
      /*height: 100vh;*/
    "
  >
    <loading v-if="loadingRender"></loading>
    <div class="row">
      <div class="col-md-1"></div>
      <div class="col-md-10 mt-5">
        <net-pa-card v-if="stage == 1 && Islogin == undefined">
          <template slot="header">
            <h6 class="text-right">
              <i class="fas fa-unlock"></i> احراز هویت
              <span class="float-left" @click="$router.go(-1)">
                <i
                  data-v-9331d9a2=""
                  title="بازگشت به صفحه قبلی"
                  class="fas fa-arrow-left text-light Pointer"
                  style="float: left; font-size: 18px"
                ></i
              ></span>
            </h6>
          </template>
          <template slot="content">
            <div class="container">
              <div class="row">
                <div class="col-12 text-center">
                  <h6 v-if="IsEstelamCodeMeli == 'false'">
                    برای دریافت کد احراز هویت کد ملی و شماره موبایل خود را وارد
                    کنید.
                  </h6>
                  <h6 v-if="IsEstelamCodeMeli == 'true'">
                    برای دریافت کد احراز هویت کد ملی ، شماره موبایل و تاریخ تولد
                    خود را وارد کنید.
                  </h6>
                  <span v-if="IsEstelamCodeMeli == 'true'" class="text-danger">
                    برای احراز هویت شما نیاز است شماره موبایل و تاریخ تولد شما
                    با اطلاعات واقعی شما مطابقت داشته باشد
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <form id="div1" class="w-100">
                    <div class="row">
                      <div class="col-3"></div>

                      <div class="col-md-6 col-12 row">
                        <div class="col-12 p-2">
                          <input
                            class="form-control text-center mt-2 required required-CodeMeli"
                            style="direction: ltr"
                            type="number"
                            v-model="CodeMeli"
                            placeholder="کد ملی"
                          />
                        </div>
                        <div
                          :class="
                            IsEstelamCodeMeli == 'true'
                              ? 'col-lg-6 col-12 p-2'
                              : 'col-12 p-2'
                          "
                        >
                          <input
                            class="form-control text-center required mt-2"
                            style="direction: ltr"
                            type="number"
                            v-model="Mobile"
                            placeholder="شماره موبایل "
                          />
                        </div>
                        <div
                          :class="
                            IsEstelamCodeMeli == 'true'
                              ? 'col-lg-6 col-12 pt-3'
                              : 'col-12 p-2'
                          "
                          v-if="IsEstelamCodeMeli == 'true'"
                        >
                          <date-picker
                            input-class="required form-control"
                            v-model="BirthDate"
                            :editable="true"
                            color="#756AB6"
                            placeholder="تاریخ تولد"
                          ></date-picker>
                        </div>
                        <div>
                          <div class="col-12 p-2">
                            <CaptchaBox
                              ref="captchaRef"
                              @update="onCaptchaValid"
                            ></CaptchaBox>
                          </div>
                        </div>
                      </div>
                      <div class="col-3"></div>
                      <div class="col-3"></div>
                      <div class="col-md-6 col-12 row">
                        <div class="col-12 p-2">
                          <button
                            :disabled="!CaptchaValid"
                            class="btn btn-submit w-100 mt-2 rounded"
                            @click.prevent="sendSms"
                          >
                            {{
                              IsEstelamCodeMeli == "true"
                                ? " احراز هویت"
                                : "ارسال پیامک"
                            }}
                          </button>
                        </div>
                        <div
                          v-if="$session.get('CustCode') == '932'"
                          class="col-12 p-2"
                        >
                          <button
                            class="btn btn-info w-100 mt-2 rounded"
                            @click.prevent="Check()"
                          >
                            پیگیری درخواست
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-3"></div>
                  </form>
                </div>
              </div>
            </div>
          </template>
        </net-pa-card>

        <net-pa-card v-if="stage == 2 && Islogin == undefined">
          <template slot="header">
            <h6 class="text-right"><i class="fas fa-unlock"></i> احراز هویت</h6>
          </template>
          <template slot="content">
            <div class="row p-3">
              <div class="col-12 text-center">
                <h6>
                  کد ارسالی شرکت نو اندیش پاسارگاد به شماره تلفن همراهتان را جهت
                  احراز هویت وارد نمائید
                </h6>
              </div>
              <div class="col-md-4"></div>
              <div class="col-md-4 col-12">
                <div class="row">
                  <div class="col-12 mt-2 mb-2">
                    <input
                      v-if="IsEstelamCodeMeli == 'false'"
                      type="number"
                      placeholder="کد احراز هویت"
                      class="form-control text-center"
                      style="direction: ltr"
                      v-model="randomKey"
                      autocomplete="off"
                      maxlength="6"
                      id="txtRandoKey"
                    />
                    <input
                      v-if="IsEstelamCodeMeli == 'true'"
                      type="number"
                      placeholder="کد احراز هویت را وارد کنید"
                      class="form-control text-center"
                      style="direction: ltr"
                      v-model="randomKey"
                      autocomplete="off"
                      id="txtRandoKey"
                    />
                  </div>
                  <div class="col-12 mt-2 mb-2">
                    <CaptchaBox
                      ref="captchaRef3"
                      @update="onCaptchaValid3"
                    ></CaptchaBox>
                  </div>
                  <div class="col-12 mt-2">
                    <button
                      class="btn w-100 btn-submit rounded"
                      :disabled="!CaptchaValid3"
                      @click="OkCode()"
                    >
                      ثبت کد
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-4"></div>
            </div>
          </template>
        </net-pa-card>
        <net-pa-card v-else-if="stage == 3 || Islogin == true">
          <template slot="header">
            <h6 class="text-right">
              <i class="fas fa-sign-in-alt"></i> درخواست عضویت
              <span class="float-left" @click="$router.go(-1)">
                <i
                  data-v-9331d9a2=""
                  title="بازگشت به صفحه قبلی"
                  class="fas fa-arrow-left text-light Pointer"
                  style="float: left; font-size: 18px"
                ></i
              ></span>
            </h6>
          </template>
          <template slot="content">
            <div class="container">
              <form id="Register">
                <div
                  class="row mt-2 mb-4"
                  style="
                    padding-bottom: 16px;
                    border-radius: 15px;
                    box-shadow: 0 10px 6px rgba(0, 0, 0, 0.02);
                  "
                >
                  <div class="w-100 text-right rounded p-1 mb-4">
                    <h6 class="text-warning font-weight-bold pr-1">
                      اطلاعات فردی
                    </h6>
                    <hr class="titleHr" />
                  </div>
                  <div class="col-md-4 col-12">
                    <small class="text-right text-dark"> نــــام : </small>
                    <input
                      autocomplete="off"
                      @keypress="$ValidPersian($event, 20)"
                      type="text"
                      id="OzvName"
                      class="form-control InputText required"
                      v-model="OzvName"
                      :disabled="FixInput == true"
                    />
                  </div>
                  <div class="col-md-4 col-12">
                    <small class="text-right text-dark"> نام خانوادگی : </small>
                    <input
                      autocomplete="off"
                      @keypress="$ValidPersian($event, 40)"
                      type="text"
                      id="OzvFamily"
                      class="form-control InputText required"
                      v-model="OzvFamily"
                      :disabled="FixInput == true"
                    />
                  </div>
                  <div class="col-md-4 col-12">
                    <small class="text-right text-dark"> کد ملی : </small>
                    <input
                      autocomplete="off"
                      type="number"
                      maxlength="10"
                      class="form-control InputText required-CodeMeli text-left"
                      @keypress="$ValidNumber($event, 10)"
                      @input="$CheckupLengthCodeMeli($event)"
                      v-model="CodeMeli"
                      :disabled="Islogin == undefined || FixInput == true"
                    />
                  </div>

                  <div class="col-md-4 col-12">
                    <small class="text-right text-dark"> تاریخ تولد : </small>
                    <date-picker
                      :editable="true"
                      v-model="BirthDate"
                      color="#ff9800"
                    ></date-picker>
                    <input
                      type="text"
                      tabindex="-1"
                      class="d-none InputText required"
                      v-model="BirthDate"
                      style="direction: ltr"
                    />
                  </div>
                  <div class="col-md-4 col-12">
                    <small class="text-right text-dark">
                      شماره شناسنامه :
                    </small>
                    <input
                      autocomplete="off"
                      type="number"
                      maxlength="10"
                      @keypress="$ValidNumber($event, 10)"
                      v-model="Shenasname"
                      id="Shenasname"
                      class="form-control InputText required"
                      style="direction: ltr"
                    />
                  </div>
                  <div class="col-md-4 col-12">
                    <small class="text-right text-dark"> نام پدر : </small>
                    <input
                      autocomplete="off"
                      v-model="Pedar"
                      type="text"
                      @keypress="$ValidPersian($event, 50)"
                      id="pedar"
                      class="form-control text-right InputText required"
                      style="direction: rtl"
                      :disabled="FixInput == true"
                    />
                  </div>

                  <div class="col-md-4 col-12">
                    <small class="text-right text-dark"> جنسیت : </small>
                    <select
                      class="form-control text-center Pointer required"
                      id="cmbSEX"
                      v-model="cmbSEX"
                      style="max-height: 100px !important"
                      :disabled="FixInput == true"
                    >
                      <option selected class="Pointer" :value="4041">
                        مرد
                      </option>
                      <option class="Pointer" :value="4042">زن</option>
                    </select>
                  </div>
                  <div class="col-md-4 col-12">
                    <small class="text-right text-dark"> وضعیت تاهل : </small>
                    <select
                      class="form-control text-center Pointer required"
                      id="cmbTaahol"
                      v-model="cmbTaahol"
                      style="max-height: 100px !important"
                    >
                      <option selected class="Pointer" :value="4068">
                        مجرد
                      </option>
                      <option class="Pointer" :value="4067">متاهل</option>
                    </select>
                  </div>
                  <div class="col-md-4 col-12">
                    <small class="text-right text-dark">
                      محل صدور شناسنامه :
                    </small>
                    <input
                      autocomplete="off"
                      v-model="Sodor"
                      type="text"
                      @keypress="$ValidPersian($event, 50)"
                      id="Sodor"
                      class="form-control text-right InputText required"
                      style="direction: rtl"
                    />
                  </div>
                  <div
                    class="col-md-4 col-12 mt-2"
                    v-if="$session.get('CustCode') == '932'"
                  >
                    <small class="text-right text-dark">
                      شماره پرسنلی /مستمری :
                    </small>
                    <input
                      autocomplete="off"
                      v-model="PerNo"
                      type="text"
                      @keypress="$ValidNumber($event, 10)"
                      id="PerNo"
                      class="form-control text-right InputText required"
                      style="direction: rtl"
                    />
                  </div>
                  <div
                    v-if="$session.get('CustCode') == '932'"
                    class="col-md-8 col-12 mt-2"
                  >
                    <small class="text-right text-dark">
                      از کجا با ما آشنا شده اید؟
                    </small>
                    <input
                      class="form-control required"
                      type="text"
                      v-model="moaref"
                    />
                  </div>
                </div>
                <div
                  class="row mt-2 mb-4"
                  style="
                    padding-bottom: 16px;
                    border-radius: 15px;
                    box-shadow: 0 10px 6px rgba(0, 0, 0, 0.02);
                  "
                >
                  <div class="w-100 text-right rounded p-1 mb-4">
                    <h6 class="text-warning pr-1 font-weight-bold">
                      اطلاعات تماس
                    </h6>
                    <hr class="titleHr" />
                  </div>
                  <div class="col-md-4 col-12">
                    <small class="text-right text-dark"> شماره همراه : </small>
                    <input
                      autocomplete="off"
                      type="number"
                      @keypress="$ValidNumber($event, 11)"
                      id="Mobile"
                      class="form-control InputText required"
                      style="direction: ltr"
                      v-model="Mobile"
                      :disabled="Islogin == undefined || FixInput == true"
                    />
                  </div>
                  <div class="col-md-4 col-12">
                    <small class="text-right text-dark"> تلفن تماس : </small>
                    <input
                      autocomplete="off"
                      type="number"
                      @keypress="$ValidNumber($event, 11)"
                      id="Tel"
                      class="form-control InputText"
                      style="direction: ltr"
                      v-model="Tel"
                    />
                  </div>
                  <!-- <div class="col-md-4 col-12">
                                    <small class="text-right text-secondary">  محل کار:  </small>
                                    <input autocomplete="off"  type="text"  id="Work" class="form-control InputText " style="direction:rtl;" v-model="Work" >
                                </div> -->
                  <div class="col-md-4 col-12">
                    <small class="text-right text-dark"> کد پستی : </small>
                    <input
                      autocomplete="off"
                      type="number"
                      @keypress="$ValidNumber($event, 10)"
                      id="CodePosti"
                      class="form-control InputText required"
                      style="direction: ltr"
                      v-model="CodePosti"
                    />
                  </div>
                  <div class="col-md-12 col-12">
                    <small class="text-right text-dark"> آدرس منزل : </small>
                    <textarea
                      autocomplete="off"
                      type="text"
                      id="Address"
                      class="form-control InputText text-right"
                      rows="1"
                      style="direction: ltr"
                      v-model="Address"
                    ></textarea>
                  </div>
                </div>
                <div
                  v-if="
                    $session.get('CustCode') != '953' &&
                    $session.get('CustCode') != '948'
                  "
                  class="row mt-2 mb-4"
                  style="
                    padding-bottom: 16px;
                    border-radius: 15px;
                    box-shadow: 0 10px 6px rgba(0, 0, 0, 0.02);
                  "
                >
                  <div class="w-100 text-right rounded p-1 mb-4">
                    <h6 class="text-warning pr-1 font-weight-bold">
                      اطلاعات بانکی
                    </h6>
                    <hr class="titleHr" />
                  </div>
                  <div
                    v-if="$session.get('CustCode') == '953'"
                    class="col-md-4 col-12"
                  >
                    <small class="text-right text-dark">
                      شماره حساب بانکی :
                    </small>
                    <input
                      autocomplete="off"
                      type="number"
                      @keypress="$ValidNumber($event, 20)"
                      id="Mobile"
                      class="form-control InputText"
                      style="direction: ltr"
                      v-model="HesabNo"
                    />
                  </div>
                  <div v-else class="col-md-4 col-12">
                    <small class="text-right text-dark">
                      شماره حساب بانکی :
                    </small>
                    <input
                      autocomplete="off"
                      type="number"
                      @keypress="$ValidNumber($event, 14, false)"
                      id="Mobile"
                      class="form-control InputText required"
                      style="direction: ltr"
                      v-model="HesabNo"
                    />
                  </div>

                  <div class="col-md-4 col-12">
                    <small class="text-right text-dark"> انتخاب بانک : </small>
                    <select
                      name="cmbBank"
                      id="cmbBank"
                      class="form-control Pointer"
                      v-model="ResultcmbBank"
                    >
                      <option
                        selected
                        v-for="item in this.ListModelBank"
                        :key="item.id"
                        :value="item.bnpCashDbtblBankId"
                      >
                        <span>{{ item.bankName }}</span>
                      </option>
                    </select>
                  </div>
                </div>
                <div
                  class="row mt-2 mb-4"
                  style="
                    padding-bottom: 16px;
                    border-radius: 15px;
                    box-shadow: 0 10px 6px rgba(0, 0, 0, 0.02);
                  "
                >
                  <div class="w-100 text-right rounded p-1 mb-4">
                    <h6 class="text-warning pr-1 font-weight-bold">
                      سایر اطلاعات
                    </h6>
                    <hr class="titleHr" />
                  </div>
                  <div class="col-md-3 col-12">
                    <small
                      v-if="$session.get('CustCode') == '801'"
                      class="text-right text-dark"
                    >
                      شعبه مورد نظر جهت عضویت :
                    </small>
                    <small v-else class="text-right text-dark">
                      {{ txtTafsilytype }}
                    </small>
                    <Dropdown
                      v-if="Islogin == undefined"
                      :options="OptionsvalidateSelection2"
                      v-on:selected="validateSelectionShobe"
                      name="TafsiliType"
                      :maxItem="50000"
                      :disabled="false"
                      placeholder="انتخاب"
                    >
                    </Dropdown>
                    <small class="text-right text-secondary" v-else>{{
                      nameTafsiliType
                    }}</small>
                  </div>
                  <div
                    v-if="$session.get('CustCode') == '932'"
                    class="col-md-3 col-12"
                  >
                    <small class="text-right text-dark">
                      نوع اداره کل بیمه یا درمان :
                    </small>
                    <Dropdown
                      :options="OptionsvalidateSelection4"
                      v-on:selected="validateSelectionJob"
                      :disabled="false"
                      name="Job"
                      :maxItem="50000"
                      placeholder="انتخاب"
                    >
                    </Dropdown>
                  </div>
                  <div
                    v-if="$session.get('CustCode') == '932'"
                    class="col-md-3 col-12"
                  >
                    <small class="text-right text-dark">
                      استان مورد نظر جهت عضویت :
                    </small>
                    <Dropdown
                      :options="OptionsvalidateSelection3"
                      v-on:selected="validateSelectionOstan"
                      :disabled="false"
                      name="grp325"
                      :maxItem="50000"
                      placeholder="انتخاب"
                    >
                    </Dropdown>
                  </div>
                  <div class="col-md-3 col-12">
                    <small
                      v-if="$session.get('CustCode') == '801'"
                      class="text-right text-dark"
                    >
                      محل کار مورد نظر جهت عضویت :
                    </small>
                    <small v-else class="text-right text-dark">
                      {{ txtAzaNo }}
                    </small>
                    <Dropdown
                      v-if="Islogin == undefined"
                      :options="OptionsvalidateSelection"
                      v-on:selected="validateSelection"
                      :disabled="false"
                      name="zipcode"
                      :maxItem="50000"
                      placeholder="انتخاب"
                    >
                    </Dropdown>
                    <small class="text-right text-secondary" v-else>{{
                      nameAzanoe
                    }}</small>
                    <!-- <select v-if="IsLoad" name="cmbAzaNoe" id="cmbAzaNoe" class="form-control Pointer" @change="GetAzaNoe()" v-model="ResultcmbcmbAzaNoeArray">
                                            <option  v-if="this.IsLoad==false" value="-2"> || در حال بارگذاری ، منتظر بمانید ... || </option>
                                            <option  selected  value="-1" >-- انتخاب محل کار --</option>
                                            <option v-for="item in this.ListModelAzaNoe"   :key="item.id" :value="item" >
                                                <span>{{item.nameHoze}}</span>
                                            </option>
                                        </select> -->
                  </div>

                  <!-- <div class="col-md-3 col-12">
                                        <small class="text-right text-dark"> شعبه افتتاح حساب :  </small>

                                       <select v-if="IsLoad" name="cmbTafsiliType" id="cmbTafsiliType" class="form-control Pointer"  v-model="ResultcmbcmbTafsiliType" disabled >
                                            <option selected v-for="item in this.ListModelTafsiliType" :key="item.id" :value="item.id" >
                                                <span>{{item.nameTafsiliType}}</span>
                                            </option>
                                        </select> 
                                    </div> -->
                  <div
                    class="col-md-3 col-12"
                    v-if="
                      $session.get('CustCode') != '932' &&
                      $session.get('CustCode') != '953' &&
                      $session.get('CustCode') != '948' &&
                      $session.get('CustCode') != '8002'
                    "
                  >
                    <small class="text-right text-dark">
                      عضویت به عنوان :
                    </small>
                    <br />
                    <div
                      class="custom-control custom-radio custom-control-inline"
                    >
                      <input
                        type="radio"
                        id="customRadioInline1"
                        name="customRadioInline"
                        class="custom-control-input"
                        @click="changeRdo"
                        :checked="rdoAsli && Islogin == undefined"
                        :disabled="Islogin"
                      />
                      <label
                        class="custom-control-label"
                        for="customRadioInline1"
                        >عضو اصلی</label
                      >
                    </div>
                    <div
                      class="custom-control custom-radio custom-control-inline"
                    >
                      <input
                        type="radio"
                        id="customRadioInline2"
                        name="customRadioInline"
                        class="custom-control-input"
                        @click="changeRdo"
                        :checked="Islogin"
                      />
                      <label
                        class="custom-control-label"
                        for="customRadioInline2"
                        >عضو وابسته</label
                      >
                    </div>
                  </div>
                  <div v-if="IsVabaste != ''" class="col-md-3 col-12">
                    <small class="text-right text-secondary">
                      کد ملی عضو اصلی:
                    </small>
                    <div class="input-group mb-3">
                      <input
                        autocomplete="off"
                        type="number"
                        maxlength="10"
                        class="form-control InputText required-CodeMeli text-left"
                        @keypress="$ValidNumber($event, 10)"
                        @input="$CheckupLengthCodeMeli($event)"
                        v-model="CodeMeliVabaste"
                        :disabled="Islogin"
                      />
                      <div class="input-group-prepend">
                        <button
                          class="btn btn-primary rounded"
                          @click="CheckCodemeli()"
                          type="button"
                          id="button-addon1"
                        >
                          بررسی
                        </button>
                      </div>
                    </div>
                    <span class="text-danger">مشخصات عضو اصلی : </span>
                    <span class="text-dark"> {{ Moshakhasat }}</span>
                  </div>
                </div>
                <div class="row mt-2 mb-4">
                  <div class="w-100 text-right rounded p-1 mb-4">
                    <h6 class="text-warning pr-1 font-weight-bold">
                      آپلود مدارک
                    </h6>
                    <hr class="titleHr" />
                  </div>
                  <div class="text-light p-3">
                    <span class="text-danger">
                      فرمت قابل قبول برای ارسال مدارک gif و jpg و jpeg و png و
                      zip و rar و pdf
                    </span>
                    <h6
                      class="mx-2"
                      v-if="
                        $cookies.isKey('RegisterForm') &
                        ($session.get('CustCode') == 886)
                      "
                    >
                      - برای دانلود فرم عضویت
                      <a
                        :href="$cookies.get('RegisterForm')"
                        download="فرم عضویت"
                        ><sapn class="badge badge-success">اینجا </sapn></a
                      >
                      کلیک کنید.
                    </h6>
                  </div>
                  <div
                    class="col-12"
                    v-if="
                      $session.get('CustCode') != 932 &&
                      $session.get('CustCode') != 953
                    "
                  >
                    <input
                      type="file"
                      @change="changefile(null, $event)"
                      class="d-none"
                      id="Uploader"
                      accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
                    />
                    <span
                      v-if="$session.get('CustCode') == 860"
                      class="text-danger mx-2"
                    >
                      بارگذاری اسکن کارت ملی، شناسنامه و عکس پرسنلی در یک فایل
                      zip الزامی است
                    </span>
                    <button
                      class="btn btn-primary mt-3 rounded"
                      @click.prevent="clickUploader('')"
                    >
                      برای بارگذاری مدارک کلیک کنید
                    </button>
                    <div
                      v-if="fileinfo.name"
                      class="alert alert-secondary text-center mt-2"
                    >
                      <b>فایل بارگذاری شده :</b>
                      <b>{{ fileinfo.name }}</b>
                    </div>
                  </div>

                  <div class="col-12" v-else>
                    <div class="row">
                      <div class="col-md-4 col-12">
                        <div>تصویر روی کارت ملی</div>
                        <input
                          type="file"
                          @change="changefile(1, $event)"
                          class="d-none"
                          :key="RenderFile1"
                          id="Uploader1"
                          accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
                        />
                        <button
                          class="btn btn-danger mt-3 mx-1 rounded"
                          @click.prevent="
                            fileinfo1 = {};
                            RenderFile1++;
                          "
                          v-if="fileinfo1.name"
                        >
                          <i class="fas fa-trash"></i>
                        </button>
                        <button
                          class="btn btn-primary mt-3 rounded"
                          @click.prevent="clickUploader(1)"
                        >
                          {{
                            fileinfo1.name
                              ? "بارگذاری مجدد فایل"
                              : "بار گذاری فایل"
                          }}
                        </button>
                        <div class="mt-3" v-if="fileinfo1.name">
                          <small class="text-secondary">
                            نام فایل : {{ fileinfo1.name }}</small
                          >
                        </div>
                        <div class="mt-2" v-if="fileinfo1.size">
                          <small class="text-secondary">
                            حجم فایل :
                            {{ (fileinfo1.size / 1000000).toFixed(2) }} MB
                          </small>
                        </div>
                      </div>
                      <div class="col-md-4 col-12">
                        <div>صفحه اول شناسنامه</div>
                        <input
                          type="file"
                          @change="changefile(2, $event)"
                          class="d-none"
                          :key="RenderFile2"
                          id="Uploader2"
                          accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
                        />
                        <button
                          class="btn btn-danger mt-3 mx-1 rounded"
                          @click.prevent="
                            fileinfo2 = {};
                            RenderFile2++;
                          "
                          v-if="fileinfo2.name"
                        >
                          <i class="fas fa-trash"></i>
                        </button>
                        <button
                          class="btn btn-primary mt-3 rounded"
                          @click.prevent="clickUploader(2)"
                        >
                          {{
                            fileinfo2.name
                              ? "بارگذاری مجدد فایل"
                              : "بار گذاری فایل"
                          }}
                        </button>
                        <div class="mt-3" v-if="fileinfo2.name">
                          <small class="text-secondary">
                            نام فایل : {{ fileinfo2.name }}</small
                          >
                        </div>
                        <div class="mt-2" v-if="fileinfo2.size">
                          <small class="text-secondary">
                            حجم فایل :
                            {{ (fileinfo2.size / 1000000).toFixed(2) }} MB
                          </small>
                        </div>
                      </div>
                      <div class="col-md-4 col-12">
                        <div>حکم کارگزینی/مستمری/بازماندگی</div>
                        <input
                          type="file"
                          @change="changefile(3, $event)"
                          class="d-none"
                          :key="RenderFile3"
                          id="Uploader3"
                          accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
                        />
                        <button
                          class="btn btn-danger mt-3 mx-1 rounded"
                          @click.prevent="
                            fileinfo3 = {};
                            RenderFile3++;
                          "
                          v-if="fileinfo3.name"
                        >
                          <i class="fas fa-trash"></i>
                        </button>
                        <button
                          class="btn btn-primary mt-3 rounded"
                          @click.prevent="clickUploader(3)"
                        >
                          {{
                            fileinfo3.name
                              ? "بارگذاری مجدد فایل"
                              : "بار گذاری فایل"
                          }}
                        </button>
                        <div class="mt-3" v-if="fileinfo3.name">
                          <small class="text-secondary">
                            نام فایل : {{ fileinfo3.name }}</small
                          >
                        </div>
                        <div class="mt-2" v-if="fileinfo3.size">
                          <small class="text-secondary">
                            حجم فایل :
                            {{ (fileinfo3.size / 1000000).toFixed(2) }} MB
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-12 mt-5 alert alert-dark"
                    v-if="$session.get('CustCode') == 932"
                  >
                    <input
                      type="checkbox"
                      class="ml-2"
                      style="transform: scale(1.3)"
                      v-model="AcceptGhavnin932"
                    />
                    <span>اینجانب </span>
                    <u
                      class="Pointer text-danger"
                      data-toggle="modal"
                      data-target="#Modal-light"
                    >
                      شرایط و ضوابط
                    </u>
                    <span>تعاونی اعتبار را مطالعه و پذیرفته ام</span>
                  </div>
                  <!-- <div class="col-md-6 col-12">
                    <small class="text-secondary"> نام فایل: </small>

                    <small v-if="fileinfo.name">
                      {{ fileinfo.name }}
                    </small>
                    <br />
                    <br />
                    <small class="text-secondary"> حجم فایل: </small>
                    <small v-if="fileinfo.size"> {{ (fileinfo.size / 1000000).toFixed(2) }} MB </small>
                  </div> -->
                </div>
              </form>
              <div class="row mt-2">
                <div class="col-12">
                  <hr />
                </div>
                <div class="col-md-4 col-12"></div>
                <div class="col-md-4 col-12">
                  <CaptchaBox
                    ref="captchaRef2"
                    @update="onCaptchaValid2"
                  ></CaptchaBox>
                </div>
                <div class="col-md-4 col-12">
                  <button
                    v-if="state == 1"
                    :disabled="!CaptchaValid2"
                    class="btn btn-block btn-lg btn-success rounded"
                    @click="SabtOzv()"
                  >
                    ثبت اطلاعات
                  </button>
                  <button
                    v-if="state == 2"
                    class="btn btn-block btn-lg btn-success rounded"
                    @click="EditOzv()"
                  >
                    ویرایش اطلاعات
                  </button>
                </div>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>
      <div class="col-md-1"></div>
    </div>
    <modal-custom>
      <template v-slot:ContentModalLight>
        <div class="container text-justify">
          <div class="text-center alert alert-secondary">
            <b
              >شرایط و ضوابط تعاونی اعتبار کارکنان سازمان تامین اجتماعی ( تکتا )
            </b>
          </div>
          <li class="mt-4" style="word-break: break-word">
                 اعضا یک ماه پس از تکمیل مبلغ اولیه سهام ( یک میلیون تومان ) به حساب تعاونی اعتبار ، می توانند نسبت به سپرده گذاری اقدام نمایند.
          </li>
          <li class="mt-4" style="word-break: break-word">
            عضو تکتا به سازمان تامین اجتماعی اجازه می دهد که تعاونی اعتبار مبلغ
            پس انداز ماهیانه( 4/950/000 ريال ) و در صورت دریافت تسهیلات ،اقساط
            آن را از حقوق یا مستمری ماهیانه وی کسر و به حساب تعاونی اعتبار واریز
            نماید.
          </li>
          <li class="mt-3" style="word-break: break-word">
            چنانچه در سنوات آتی، مجمع عمومی تعاونی اعتبار مبلغ پرداخت مستمر پس
            انداز ماهیانه( 4/950/000 ريال ) را افزایش دهد موافقت خویش را با
            افزیش آن اعلام می دارم.
          </li>
          <li class="mt-3" style="word-break: break-word">
            از شرایط و مبالغ کسر پس انداز ماهیانه و دریافت تسهیلات و پرداخت
            اقساط اطلاع دارم.
          </li>
          <li class="mt-3" style="word-break: break-word">
            تمامی مطالبات اعم از(پس اندازهای کسر شده و مبلغ خرید سهام) در زمان
            انصراف به حساب سهامدار مسترد می گردد.
          </li>
          <li class="mt-3" style="word-break: break-word">
            مسؤلیت صحیح بودن اطلاعات ثبت شده در هنگام ثبت‌نام به عهده‌ی شخص
            کاربر خواهد بود.
          </li>
          <li class="mt-3" style="word-break: break-word">
            در مورد اطلاع از وضعیت ثبت نام،کد پیگیری توسط تکتا به شماره همراه
            شما ارسال خواهد شد، در صفحه نخست وب سایت به قسمت پیگیری، مراجعه
            نمائید. همچنین پس از ثبت نام شما در وب‌سایت، و تائیدیه کارشناسان
            مربوطه، پیامکی مبنی بر ثبت موفق اطلاعات شما درتعاونی اعتبار و آدرس
            کانال های ارتباطی جهت عضویت، ارسال خواهد شد.
          </li>
          <li class="mt-3" style="word-break: break-word">
            با توجه به الزامی بودن ثبت اطلاعات شما برای تکمیل فرایند ثبت نام، وب
            سایت تعاونی اعتبار امنیت اطلاعات خصوصی شما را تضمین و در جهت حفظ و
            نگهداری اطلاعات خصوصی افراد تلاش می‌نماید.
          </li>
          <li class="mt-3" style="word-break: break-word">
            همچنین متعهد میگردم که در هیچ یک از تعاونی اعتبار دیگری عضو نمیباشم.
          </li>
          <li class="mt-3" style="word-break: break-word">
            اعضاء یکماه پس از تاریخ عضویت، می توانند نسبت به سپرده گذاری اقدام
            نمایند
          </li>
          <p class="mt-5 text-center text-dark font-weight-bold">
            (( اینجانب موارد ذکر شده را مطالعه نموده و موافقت خود را در جهت
            اقدامات مربوطه اعلام می دارم ))
          </p>
          <div class="mb-5">
            <button
              class="btn btn-success float-left mb-5 rounded"
              data-dismiss="modal"
            >
              قوانین را مطالعه کردم
            </button>
          </div>
        </div>
      </template>
    </modal-custom>
  </div>
</template>
<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import loading from "../Tools/NetPa/Loading.vue";
import Dropdown from "vue-simple-search-dropdown";
import JSZip from "jszip";
import ModalCustom from "../Tools/ModalCustom.vue";
import CaptchaBox from "../CmpLogin/CaptchaBox.vue";
export default {
  data() {
    return {
      CodePosti: "",
      captchaText3: "",
      captchaId3: "",
      CaptchaValid3: false,
      captchaText2: "",
      captchaId2: "",
      CaptchaValid2: false,
      captchaText: "",
      captchaId: "",
      CaptchaValid: false,
      txtAzaNo: "دسته بندی",
      txtTafsilytype:
        this.$session.get("CustCode") == "932" ? "وضعیت اشتغال " : "نوع عضویت",
      stage: 1,
      OzvName: "",
      OzvFamily: "",
      CodeMeli: null,
      BirthDate: "",
      Shenasname: null,
      Pedar: "",
      cmbSEX: null,
      cmbTaahol: null,
      Sodor: "",
      PerNo: null,
      Mobile: "",
      Tel: null,
      Work: "",
      Address: "",
      cmbShobe: null,
      ResultcmbcmbAzaNoeArray: null,
      IsLoad: false,
      ListModelAzaNoe: null,
      loadingRender: false,
      DataAxios: {
        ArryfildValue: "",
        Method: "Post",
        Action: "EftetahHesab/NewAzaNetPa",
        Token: "",
      },
      DataAxiosEdit: {
        ArryfildValue: "",
        Method: "Post",
        Action: "EftetahHesab/UpdateNewAzaNetPa",
        Token: "",
      },
      DataAxiosUpload: {
        ArryfildValue: "",
        Method: "Post",
        Action: "EftetahHesab/SaveAttachmentToDb",
        Token: "",
      },
      rdoAsli: true,
      CodeMeliVabaste: "",
      IsVabaste: false,
      Moshakhasat: "",
      wwwtblAzaIdSahebHesab: null,
      ListModelTafsiliType: null,
      ResultcmbcmbTafsiliType: null,
      ResultcmbGrp325: null,
      fileinfo: {},
      fileinfo1: {},
      fileinfo2: {},
      fileinfo3: {},
      fileinfo1Isedit: false,
      fileinfo2Isedit: false,
      fileinfo3Isedit: false,
      RenderFile1: 0,
      RenderFile2: 0,
      RenderFile3: 0,
      OptionsvalidateSelection: [],
      OptionsvalidateSelection2: [],
      OptionsvalidateSelection3: [],
      OptionsvalidateSelection4: [],
      ListModelTafsily: null,
      ListModelBank: null,
      ResultcmbBank: null,
      HesabNo: 0,
      randomKey: "",
      bnpCashDbtblTafsiliTypeId: null,
      nameTafsiliType: "",
      nameAzanoe: "",
      IdEftetah: 0,
      ResultEstelamCodeMeli: {},
      MsgEstelamCodeMeli: "",
      EstelamCodeMeli: {},
      FixInput: false,
      FileZip: "",
      MultiFile: false,
      state: 1,
      AcceptGhavnin932: false,
      moaref: "",
      wwwtblJobId: null,
      IsEstelamCodeMeli: false,
    };
  },
  components: {
    NetPaCard,
    datePicker: VuePersianDatetimePicker,
    loading,
    Dropdown,
    ModalCustom,
    CaptchaBox,
  },
  props: ["Islogin", "RegisterCheck"],
  created() {
    
    this.$GetAppsettingsAsync()
      .then(() => {
        this.gettblCustomer();
      })
      .catch(() => {
        this.gettblCustomer();
      });
  },
  mounted() {
    this.randomKey = "";

    if (this.Islogin == true && this.Islogin != undefined) {
      this.rdoAsli = false;
      this.IsVabaste = true;
      this.CodeMeliVabaste = this.$session.get("UserInfoNetPa").codeMeli.trim();
      this.Moshakhasat =
        JSON.parse(JSON.stringify(this.$session.get("UserInfoNetPa"))).ozvName +
        " " +
        JSON.parse(JSON.stringify(this.$session.get("UserInfoNetPa")))
          .ozvFamily;
      this.wwwtblAzaIdSahebHesab = this.$session.get("UserInfoNetPa").id;
      var formdata2 = new FormData();
      formdata2.append("custcode", this.$session.get("CustCode"));
      var DataAxios_TafsiliType2 = {
        ArryfildValue: formdata2,
        Method: "Post",
        Action: "TafsiliType/GetAll",
        Token: "",
      };

      this.$PostFormData(DataAxios_TafsiliType2)
        .then((res) => {
          // console.log(res);
          this.ListModelTafsily = res;
          var a = res.filter(
            (i) =>
              i.id == this.$session.get("UserInfoNetPa").wwwtblTafsiliTypeId,
          );
          this.nameTafsiliType = a[0].nameTafsiliType;
          this.ResultcmbcmbTafsiliType = a;
          this.loadingRender = false;
          this.bnpCashDbtblTafsiliTypeId = a[0].bnpCashDbtblTafsiliTypeId;
        })
        .finally(() => {
          this.$PostFormData({
            ArryfildValue: "",
            Action: "TafsiliType/GetTblBank",
            method: "post",
            Token: "",
          })
            .then((res) => {
              this.ListModelBank = res;
              this.ResultcmbBank = res[0].bnpCashDbtblBankId;
            })
            .finally(() => {
              this.loadingRender = true;
              var formdata = new FormData();
              formdata.append("BnpId", this.bnpCashDbtblTafsiliTypeId);
              formdata.append("custcode", this.$session.get("CustCode"));
              var DataAxios_TafsiliType = {
                ArryfildValue: formdata,
                Method: "Post",
                Action: "AzaNoe/GetIndex",
                Token: "",
              };
              this.$PostFormData(DataAxios_TafsiliType)
                .then((data) => {
                  var b = data.filter(
                    (x) =>
                      x.id == this.$session.get("UserInfoNetPa").wwwtblAzaNoeId,
                  );
                  this.nameAzanoe = b[0].nameHoze;
                  this.ResultcmbcmbAzaNoeArray = b;
                })
                .finally(() => {
                  this.loadingRender = false;
                });
            });
        });
    } else if (this.RegisterCheck != 0 && this.RegisterCheck != undefined) {
      this.state = 2;
      this.gettblCustomer();
      this.GetAzaAndAttach(this.RegisterCheck);
      //this.stage=3
    } else {      
      this.gettblCustomer();
    }
  },
  updated() {},
  methods: {
    async getApiBaseReady() {
      let base = this.$GetapiBase();
      if (!base) {
        await this.$GetAppsettings();
        base = this.$GetapiBase();
      }
      return base || "";
    },
  async  gettblCustomer() {
       const apiBase = await this.getApiBaseReady();
          this.IsEstelamCodeMeli =
      this.$GetIsEstelamCodeMeli() == ""
        ? sessionStorage.getItem("IsEstelamCodeMeli")
        : this.$GetIsEstelamCodeMeli();
      this.loadingRender = true;
      var settings = {
        method: "Post",
        url: apiBase + "Setting",
        headers: {},
        data: null,
      };
      var axios = require("axios");
      //   console.log('settings',settings);
      axios(settings).then((result) => {
        this.$PostData({
          ArryfildValue: {},
          Action: "GetTblCustomer",
          method: "GET",
          Token: "",
        })
          .then((data) => {
            // console.log('dataaa',data);
            this.$store.state.NameSandogh = data.name;
            this.$session.set("NameSandogh", data.name);
            this.$session.set("CustCode", data.custCode);
            document.title = " خدمات الکترونیکی " + data.name;
            this.txtTafsilytype =this.$session.get("CustCode") == "932" ? "وضعیت اشتغال " : "نوع عضویت";
            this.filCombo();
            this.loadingRender = false;
          })
          .catch(function (error) {
            //console.log(error)
          });
      });
    },
    onCaptchaValid({ valid, captchaId, userInput }) {
      this.CaptchaValid = valid;
      this.captchaId = captchaId;
      this.captchaText = userInput;
    },
    onCaptchaValid2({ valid, captchaId, userInput }) {
      this.CaptchaValid2 = valid;
      this.captchaId2 = captchaId;
      this.captchaText2 = userInput;
    },
    onCaptchaValid3({ valid, captchaId, userInput }) {
      this.CaptchaValid3 = valid;
      this.captchaId3 = captchaId;
      this.captchaText3 = userInput;
    },
    refreshCaptcha() {
      this.$refs.captchaRef.generateCaptcha();
      this.$refs.captchaRef2.generateCaptcha();
    },
    Check() {
      this.$router.push("/RegisterCheck/0");
    },
    filCombo() {
      var formdata = new FormData();
      formdata.append("custcode", this.$session.get("CustCode"));
      var DataAxios_TafsiliType2 = {
        ArryfildValue: formdata,
        Method: "Post",
        Action: "TafsiliType/GetAll",
        Token: this.$session.get("TokenNetPa"),
      };

      this.$PostFormData(DataAxios_TafsiliType2)
        .then((res) => {
          this.OptionsvalidateSelection2=[]
         // console.log(res);
          this.ListModelTafsily = res;
          for (let index = 0; index < this.ListModelTafsily.length; index++) {
            const element = this.ListModelTafsily[index];

            if (element.id != 3527160) {
              var option = {
                name: element.nameTafsiliType,
                id: element,
              };
              if (this.$session.get("CustCode") == "948") {
                if (element.bnpCashDbtblTafsiliTypeId === 291) {
                  this.OptionsvalidateSelection2.push(option);
                }
              } else if (this.$session.get("CustCode") == "860") {
                //اطلاعات نوع عضویت عام برای مشتریانی که فقط عضویت عام میخواهند
                if (element.bnpCashDbtblTafsiliTypeId == 100423) {
                  this.OptionsvalidateSelection2.push(option);
                }
              } else {
                this.OptionsvalidateSelection2.push(option);
              }
            }
          }
          this.loadingRender = false;
        })
        .finally(() => {
          this.$PostFormData({
            ArryfildValue: "",
            Action: "TafsiliType/GetTblBank",
            method: "post",
            Token: "",
          })
            .then((res) => {
              this.ListModelBank = res;
              this.ResultcmbBank = res[0].id;
            })
            .finally(() => {
              if (this.$session.get("CustCode") == "932") {
                this.GetcmbGrp325();
              }
            });
        });
    },
    GetAzaAndAttach(id) {
      // alert()
      var formdata = new FormData();
      formdata.append("Id", id);
      var DataAxios_GetAza = {
        ArryfildValue: formdata,
        Method: "Post",
        Action: "NewtblAza/GetWwwNewtblAzaById",
        Token: "",
      };
      this.$PostFormData(DataAxios_GetAza)
        .then((res) => {
          //console.log(res);
          if (res != null) {
            this.stage = 3;
            this.FixInput = true;
            this.OzvName = res.ozvName;
            this.OzvFamily = res.ozvFamily;
            this.CodeMeli = res.codeMeli;
            this.BirthDate = res.birthDate;
            this.cmbSEX = res.tblComboIdSex13;
            this.Mobile = res.mobile;
            this.Pedar = res.pedar;
            this.Address = res.adres;
            this.Tel = res.tel;
            this.Shenasname = res.shenasname;
            this.PerNo = res.perNo;
            this.cmbTaahol = res.tblComboIdTahol19;
            this.HesabNo = Number(res.hesabNo.trim());
            this.ResultcmbBank = res.wwwtblBankId;
            this.ResultcmbcmbTafsiliType = res.wwwtblTafsiliTypeId;
            this.ResultcmbcmbAzaNoeArray = res.wwwtblAzaNoeId;
            this.GetDataRegister();
          } else {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "خطایی رخ داد است",
              "error",
              2000,
            );
            this.loadingRender = false;
          }
        })
        .finally(() => {
          var formdata2 = new FormData();
          formdata2.append("MasterId", id);
          var DataAxios_GetAzaAttach = {
            ArryfildValue: formdata2,
            Method: "Post",
            Action: "NewtblAza/GetAttachment",
            Token: "",
          };
          this.$PostFormData(DataAxios_GetAzaAttach).then((res) => {
            // console.log(res);

            if (res != null) {
              this.setFile(res);
            }
          });
        });
    },
    // GetAzaNoe(){
    //     if(this.ResultcmbcmbAzaNoeArray!=undefined){
    //     if(this.ResultcmbcmbAzaNoeArray.bnpCashDBtblTafsiliTypeId>0 ){
    //         var formdata = new FormData()
    //         formdata.append("BnpId" , this.ResultcmbcmbAzaNoeArray.bnpCashDBtblTafsiliTypeId)
    //         var DataAxios_TafsiliType = { ArryfildValue: formdata,Method: "Post",Action: "TafsiliType",Token: ''}
    //         this.$PostFormData(DataAxios_TafsiliType).then(data =>{
    //             this.ListModelTafsiliType=null
    //             this.ListModelTafsiliType=data
    //             this.ResultcmbcmbTafsiliType=data[0].id
    //         })

    //     }
    //     else{
    //         this.$mySweetDefaultTost('عملیات ناموفق', ' مشکل در بارگذاری شعبه مذکور', 'error', 4000)
    //         this.ResultcmbcmbTafsiliType=null
    //                     return;
    //     }
    //     }
    // },
    async zip() {
      let filedata;
      let base64;
      let isImage;
      let fileFormat;
      let zip = new JSZip();
      zip.file(this.fileinfo1.name, this.fileinfo1);
      zip.file(this.fileinfo2.name, this.fileinfo2);
      if (this.fileinfo3 && this.fileinfo3.name) {
        zip.file(this.fileinfo3.name, this.fileinfo3);
      }
      await zip
        .generateAsync({ type: "base64" })
        .then(function (Convertbase64) {
          filedata = "data:application/zip;base64," + Convertbase64;
        })
        .finally(() => {
          base64 = filedata;
          base64 = base64.split(",")[1];
          isImage = false;
          fileFormat = "zip";
        });
      // this.File = 'data:application/zip;base64,' + base64
      this.FileZip = base64;
      var formdata3 = new FormData();
      formdata3.append("IdEftetah", this.IdEftetah);
      formdata3.append("Image", document.getElementById("Uploader1").files[0]);
      formdata3.append("TableName", " ");
      formdata3.append("wwwtblcomboidgrp328", 181070514);
      this.DataAxiosUpload.ArryfildValue = formdata3;
      this.$PostFormData(this.DataAxiosUpload).then((data) => {});
      var formdata1 = new FormData();
      formdata1.append("IdEftetah", this.IdEftetah);
      formdata1.append("TableName", " ");
      formdata1.append("Image", document.getElementById("Uploader2").files[0]);
      formdata1.append("wwwtblcomboidgrp328", 181070505);
      this.DataAxiosUpload.ArryfildValue = formdata1;
      this.$PostFormData(this.DataAxiosUpload).then((data) => {});
      if (this.fileinfo3 && this.fileinfo3.name) {
        var formdata2 = new FormData();
        formdata2.append("IdEftetah", this.IdEftetah);
        formdata2.append("TableName", " ");
        formdata2.append(
          "Image",
          document.getElementById("Uploader3").files[0],
        );
        formdata2.append("wwwtblcomboidgrp328", 181070516);
        this.DataAxiosUpload.ArryfildValue = formdata2;
        this.$PostFormData(this.DataAxiosUpload).then((data) => {});
      }

      return base64;
    },
    async SaveImages() {
      var formdata3 = new FormData();
      formdata3.append("IdEftetah", this.IdEftetah);
      formdata3.append("Image", document.getElementById("Uploader1").files[0]);
      this.DataAxiosUpload.ArryfildValue = formdata3;
      this.$PostFormData(this.DataAxiosUpload).then((data) => {
        if (data.status == "Ok") {
          var formdata1 = new FormData();
          formdata1.append("IdEftetah", this.IdEftetah);
          formdata1.append(
            "Image",
            document.getElementById("Uploader2").files[0],
          );
          this.DataAxiosUpload.ArryfildValue = formdata1;
          this.$PostFormData(this.DataAxiosUpload).then((data) => {
            if (data.status == "Ok") {
              var formdata2 = new FormData();
              formdata2.append("IdEftetah", this.IdEftetah);
              formdata2.append(
                "Image",
                document.getElementById("Uploader3").files[0],
              );
              this.DataAxiosUpload.ArryfildValue = formdata2;
              this.$PostFormData(this.DataAxiosUpload).then((data) => {
                if (data.status == "Ok") {
                }
              });
            }
          });
        }
      });
    },
    isBase64(str) {
      try {
        return btoa(atob(str)) == str;
      } catch (err) {
        return false;
      }
    },
    sendSms() {
      if (this.$ValidForm("div1")) {
        if (this.CodeMeli == "") {
          this.refreshCaptcha();
          this.$mySweetDefaultTost(
            "خطا",
            " کد ملی نمیتواند خالی باشد.",
            "error",
            2000,
          );
          return;
        }
        if (this.Mobile == "") {
          this.$mySweetDefaultTost(
            "خطا",
            "  شماره همراه نمیتواند خالی باشد.",
            "error",
            2000,
          );
          return;
        }

        if (this.Mobile.length != 11) {
          this.refreshCaptcha();
          this.$mySweetDefaultTost(
            "خطا",
            "  شماره همراه 11 رقمی است.",
            "error",
            2000,
          );
          return;
        }
        if (this.CodeMeli.length != 10) {
          this.refreshCaptcha();
          this.$mySweetDefaultTost(
            "خطا",
            "  کد ملی  10 رقمی است.",
            "error",
            2000,
          );
          return;
        }
        if (!this.CaptchaValid) {
          this.refreshCaptcha();
          this.$mySweetDefaultTost(
            "خطا",
            " متن تصویر به درستی وارد نشده است",
            "error",
            2000,
          );
          return;
        } else {
          this.loadingRender = true;
          if (this.IsEstelamCodeMeli == "true") {
            let Model = {
              CodeMeli: this.CodeMeli,
              Mobile: this.Mobile,
              BirthDate: this.BirthDate,
              CustCode: this.$session.get("CustCode"),
            };
            this.$PostData_new("GetInfocodeMeli", "POST", Model).then((re) => {
              if (re.result == "false") {
                this.MsgEstelamCodeMeli = re.msg;
                this.$mySweetDefaultTost("خطا", re.msg, "error", 3800);
                this.loadingRender = false;
              }
              if (re.result == "faild") {
                this.MsgEstelamCodeMeli = re.msg;
                this.$mySweetDefaultTost(
                  "عدم احراز هویت",
                  re.msg,
                  "warning",
                  4500,
                );
                this.loadingRender = false;
              }
              if (re.result == "success" && re.type == "2") {
                var DataAxiosRegisterAuth = {
                  ArryfildValue: {},
                  Action: "EftetahHesab/RegisterAuth",
                  Method: "POST",
                  Token: "",
                };
                const formData = new FormData();
                formData.append("mobile", this.Mobile);
                formData.append("codeMeli", this.CodeMeli);
                formData.append("userInput", this.captchaText);
                formData.append("captchaId", this.captchaId);
                formData.append("IsSendSms", false);
                DataAxiosRegisterAuth.ArryfildValue = formData;
                this.$PostFormData(DataAxiosRegisterAuth).then((data) => {});
                this.ResultEstelamCodeMeli = re.data;
                this.stage = 2;
                this.$mySweetDefaultTost(
                  "ارسال موفق",
                  "کد احراز هویت برای شما پیامک شد ، دریافت کد به علت ترافیک پیامک ها ممکن است کمی زمان بر باشد",
                  "success",
                  4500,
                );
                this.loadingRender = false;
              }
              if (re.result == "success" && re.type == "1") {
                var DataAxiosRegisterAuth = {
                  ArryfildValue: {},
                  Action: "EftetahHesab/RegisterAuth",
                  Method: "POST",
                  Token: "",
                };
                const formData = new FormData();
                formData.append("mobile", this.Mobile);
                formData.append("codeMeli", this.CodeMeli);
                formData.append("userInput", this.captchaText);
                formData.append("captchaId", this.captchaId);
                formData.append("IsSendSms", false);
                DataAxiosRegisterAuth.ArryfildValue = formData;
                this.$PostFormData(DataAxiosRegisterAuth).then((data) => {});
                this.EstelamCodeMeli = re.data;
                this.FixInput = true;
                this.OzvName = re.data.name;
                this.OzvFamily = re.data.family;
                this.CodeMeli = re.data.idCode;
                this.BirthDate = re.data.birthDate;
                this.cmbSEX = re.data.gender === "مرد" ? 4041 : 4042;
                this.Mobile = re.data.mobile;
                this.Pedar = re.data.fatherName;
                this.Shenasname = re.data.shomareShenasname;
                this.stage = 3;
                this.GetDataRegister();
              }
              this.loadingRender = false;
            });
          } else {
            var DataAxiosRegisterAuth = {
              ArryfildValue: {},
              Action: "EftetahHesab/RegisterAuth",
              Method: "POST",
              Token: "",
            };
            const formData = new FormData();
            formData.append("mobile", this.Mobile);
            formData.append("codeMeli", this.CodeMeli);
            formData.append("userInput", this.captchaText);
            formData.append("captchaId", this.captchaId);
            formData.append("IsSendSms", true);
            DataAxiosRegisterAuth.ArryfildValue = formData;
            this.$PostFormData(DataAxiosRegisterAuth)
              .then((data) => {
                this.$mySweetDefaultTost(" ", data.msg, data.icone, 3000);
                if (data.status == "Ok") {
                  this.stage = 2;
                  this.loadingRender = false;
                } else {
                  this.stage = 1;
                  this.loadingRender = false;
                }
              })
              .finally(() => {
                document.getElementById("txtRandoKey").focus();
              });
          }
        }
      }
    },
    OkCode() {
      this.loadingRender = true;
      if (this.IsEstelamCodeMeli == "true") {
        let Model = {
          ResultId: this.ResultEstelamCodeMeli.result.id,
          ComfirmMobile: this.randomKey,
        };
        this.$PostData_new("GetInfocodeMeliByOTP", "POST", Model).then((re) => {
          if (re == null || re.result == "false" || re.result.idCode == null) {
            this.MsgEstelamCodeMeli = re.msg;
            this.$mySweetDefaultTost(
              "خطا",
              re.result == "false" ? re.msg : "خطا در بررسی کد احراز هویت",
              "error",
              4800,
            );
            this.loadingRender = false;
            this.stage = 2;
          }
          if (re.result.id != null && re.result.id.trim() != "") {
            this.loadingRender = false;

            this.$mySweetDefaultTost(
              "احراز موفق",
              "کاربر گرامی : " +
                re.result.name +
                " " +
                re.result.family +
                "احراز هویت شما با موفقیت انجام گردید",
              "success",
              4800,
            );
            this.stage = 3;
            this.EstelamCodeMeli = re;
            this.FixInput = true;
            this.OzvName = re.result.name;
            this.OzvFamily = re.result.family;
            this.CodeMeli = re.result.idCode;
            this.BirthDate = re.result.birthDate;
            this.cmbSEX = re.result.gender === "مرد" ? 4041 : 4042;
            this.Mobile = re.result.mobile;
            this.Pedar = re.result.fatherName;
            this.Shenasname = re.result.nationalId;
            this.GetDataRegister();
          } else {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "خطایی رخ داد است",
              "error",
              2000,
            );
            this.loadingRender = false;
          }
          this.loadingRender = false;
        });
      } else {
        var DataAxiosDataAxiosRegisterAuth = {
          ArryfildValue: {},
          Action: "EftetahHesab/RegisterOK",
          Method: "POST",
          Token: "",
        };
        const formData = new FormData();

        formData.append("codeMeli", this.CodeMeli);
        formData.append("randomKey", this.randomKey);
        formData.append("userInput", this.captchaText3);
        formData.append("captchaId", this.captchaId3);
        DataAxiosDataAxiosRegisterAuth.ArryfildValue = formData;
        this.$PostFormData(DataAxiosDataAxiosRegisterAuth).then((data) => {
          this.$mySweetDefaultTost(" ", data.msg, data.icone, 4000);
          if (data.status == "Ok") {
            this.stage = 3;
            this.GetDataRegister();
            this.loadingRender = false;
          } else {
            this.loadingRender = false;
            this.stage = 2;
          }
        });
      }
    },
    SabtOzv() {
      // console.log(this.ResultcmbcmbTafsiliType);

      if (this.$requiredCodeMeli("Register")) {
        if (this.$ValidForm("Register")) {
          if (this.IsVabaste) {
            if (this.CodeMeliVabaste == "") {
              this.$mySweetDefaultTost(
                "عملیات ناموفق",
                " لطفا کد ملی فرد اصلی را وارد نمایید ",
                "error",
                4000,
              );
              return;
            }
            if (this.CodeMeliVabaste == this.CodeMeli) {
              this.$mySweetDefaultTost(
                "عملیات ناموفق",
                " کد ملی وارد شده با کد ملی فرد وابسته نمیتواند یکسان باشد ",
                "error",
                4000,
              );
              return;
            }
            if (this.wwwtblAzaIdSahebHesab == 0) {
              this.$mySweetDefaultTost(
                "عملیات ناموفق",
                " کد ملی وارد شده برای فرد اصلی معتبر نمیباشد",
                "error",
                4000,
              );
              return;
            }
          }
          if (
            (this.ResultcmbcmbTafsiliType == null ||
              this.ResultcmbcmbAzaNoeArray == undefined) &&
            this.$session.get("CustCode") == "801"
          ) {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              " اتخاب محل کار و شعبه افتتاح کننده حساب اجباری است",
              "error",
              4000,
            );
            return;
          }
          if (
            (this.wwwtblJobId == null ||
              this.wwwtblJobId == undefined ||
              this.wwwtblJobId == 0) &&
            this.$session.get("CustCode") == "932"
          ) {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              " اتخاب نوع اداره کل بیمه یا درمان اجباری است",
              "error",
              4000,
            );
            return;
          }
          if (
            (this.ResultcmbcmbTafsiliType == null ||
              this.ResultcmbcmbTafsiliType == undefined ||
              this.ResultcmbcmbTafsiliType == 0) &&
            this.$session.get("CustCode") != "953"
          ) {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "لطفا نوع عضویت را از بخش سایر اطلاعات انتخاب نمایید",
              "error",
              2000,
            );
            return;
          }
          if (
            (this.ResultcmbcmbAzaNoeArray == null ||
              this.ResultcmbcmbAzaNoeArray == undefined ||
              this.ResultcmbcmbAzaNoeArray == 0) &&
            this.$session.get("CustCode") != "953"
          ) {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "لطفا دسته بندی را از بخش سایر اطلاعات انتخاب نمایید",
              "error",
              2000,
            );
            return;
          }
          if (!this.CaptchaValid2) {
            this.refreshCaptcha();
            this.$mySweetDefaultTost(
              "خطا",
              " متن تصویر به درستی وارد نشده است",
              "error",
              2000,
            );
            return;
          }
          this.loadingRender = true;
          this.DataAxios.ArryfildValue = {
            OzvName: this.OzvName,
            OzvFamily: this.OzvFamily,
            Pedar: this.Pedar,
            Shenasname: this.Shenasname,
            Email: "",
            MahalSodor: this.Sodor,
            CodeMeli: this.CodeMeli,
            Adres: this.Address,
            Tel: this.Tel,
            Mobile: this.Mobile,
            tblComboIdSex13: this.cmbSEX,
            tblComboIdTahol19: this.cmbTaahol,

            wwwtblTafsiliTypeId:
              this.Islogin == undefined
                ? this.$session.get("CustCode") != "953"
                  ? this.ResultcmbcmbTafsiliType.id
                  : 0
                : this.ResultcmbcmbTafsiliType[0].id,
            wwwtblAzaNoeId:
              this.Islogin == undefined
                ? this.$session.get("CustCode") != "953"
                  ? this.ResultcmbcmbAzaNoeArray.id
                  : 0
                : this.ResultcmbcmbAzaNoeArray[0].id,
            PerNo: this.PerNo,
            HesabNo: this.HesabNo + "",
            tblBankId: this.ResultcmbBank,
            wwwtblAzaIdSahebHesab:
              this.$session.get("CustCode") == "948"
                ? 0
                : this.wwwtblAzaIdSahebHesab != null
                ? this.wwwtblAzaIdSahebHesab
                : 0,
            BirthDate: this.BirthDate,
            desMoaref: this.moaref,
            wwwtblJobsId: this.wwwtblJobId,
            userInput: this.captchaText2,
            captchaId: this.captchaId2,
            CodePosti: this.CodePosti,
            BnpCashDBtblTafsiliTypeId:
              this.ResultcmbcmbTafsiliType.bnpCashDbtblTafsiliTypeId,
            BnpCashDBtblAzaNoeId:
              this.ResultcmbcmbAzaNoeArray.bnpCashDbtblAzaNoeId,
          };

          if (this.$session.get("CustCode") == "860" && !this.fileinfo.name) {
            this.loadingRender = false;
            this.$mySweetDefaultTost(
              "آپلود ناموفق",
              " لطفا فایل خواسته شده را بارگذاری ، سپس دوباره اقدام به درخواست ثبت عضویت خود کنید ",
              "error",
              2000,
            );
            return;
          }

          if (
            this.$session.get("CustCode") == "932" &&
            (!this.fileinfo1.name ||
              !this.fileinfo2.name ||
              !this.fileinfo3.name)
          ) {
            this.loadingRender = false;
            this.$mySweetDefaultTost(
              "آپلود ناموفق",
              " لطفا هر سه فایل خواسته شده را بارگذاری ، سپس دوباره اقدام به درخواست ثبت عضویت خود کنید ",
              "error",
              2000,
            );
            return;
          }
          if (
            this.$session.get("CustCode") == "953" &&
            (!this.fileinfo1.name || !this.fileinfo2.name)
          ) {
            this.loadingRender = false;
            this.$mySweetDefaultTost(
              "آپلود ناموفق",
              " لطفا فایل های تصاویر شناسنامه و کارت ملی خودرا بارگذاری ، سپس دوباره اقدام به درخواست ثبت عضویت خود کنید ",
              "error",
              2000,
            );
            return;
          }
          if (
            this.$session.get("CustCode") == "932" &&
            this.AcceptGhavnin932 == false
          ) {
            this.loadingRender = false;
            this.$mySweetDefaultTost(
              "عدم پذیرش شرایط و ضوابط",
              " لطفا درصورت پذیرش شرایط و ضوابط تیک پذیرش را بزنید و سپس نسبت به ثبت اطلاعات اقدام فرمایید . ",
              "error",
              4000,
            );
            return;
          }

          // console.log(this.DataAxios)
          this.$PostData(this.DataAxios)
            .then((data) => {
              if (data.status == "NoSUCCESS_2") {
                this.loadingRender = false;
                this.$mySweetDefaultTost(
                  "عملیات ناموفق",
                  " درخواست عضویت شما قبلا ثبت شده است لطفا نتیجه را از شعبه استعلام نمایید ",
                  "error",
                  4000,
                );
                return;
              } else if (data.status == "NoSUCCESS_1") {
                this.loadingRender = false;
                this.$mySweetDefaultTost(
                  "عملیات ناموفق",
                  " شما در حال حاضر عضو میباشید و امکان درخواست عضویت وجود ندارد",
                  "error",
                  4000,
                );
                return;
              } else if (data.status == "NotOk") {
                this.$mySweetDefaultTost(
                  "عملیات ناموفق",
                  data.msg,
                  data.icone,
                  4000,
                );
              } else {
                this.IdEftetah = data.id;
                this.loadingRender = false;
                this.$mySweetDefaultTost(
                  "عملیات موفق",
                  "درخواست شما با موفقیت ثبت شد.",
                  "success",
                  5000,
                );

                if (
                  this.$session.get("CustCode") != "932" &&
                  this.$session.get("CustCode") != "953" &&
                  this.fileinfo.name
                ) {
                  this.loadingRender = false;
                  var formdata = new FormData();
                  formdata.append("IdEftetah", this.IdEftetah);
                  formdata.append(
                    "Image",
                    document.getElementById("Uploader").files[0],
                  );
                  this.DataAxiosUpload.ArryfildValue = formdata;
                  this.$PostFormData(this.DataAxiosUpload).then((data) => {
                    if (data.status == "Ok") {
                      this.loadingRender = false;
                      this.$router.push({ name: "LoginPage" });
                      return;
                      //this.$mySweetDefaultTost('عملیات موفق', 'درخواست شما با موفقیت ثبت شد.', 'success', 3000)
                    } else {
                      this.loadingRender = false;
                      this.$mySweetDefaultTost(
                        "عملیات ناموفق",
                        " مشکلی در بارگذاری مدارک بوجود آمده است. دوباره تلاش کنید",
                        "error",
                        4000,
                      );
                      return;
                    }
                  });
                }

                if (
                  (this.$session.get("CustCode") == "932" ||
                    this.$session.get("CustCode") == "953") &&
                  (this.fileinfo1.name ||
                    this.fileinfo2.name ||
                    this.fileinfo3.name)
                ) {
                  this.loadingRender = false;
                  var formdata = new FormData();
                  this.zip().then((file) => {
                    formdata.append("Image", JSON.stringify(file));
                    formdata.append("IdEftetah", this.IdEftetah);
                    this.DataAxiosUpload.ArryfildValue = formdata;
                    this.DataAxiosUpload.Action =
                      "EftetahHesab/UploadAtachment";
                    this.$PostFormData(this.DataAxiosUpload).then((data) => {
                      if (data.status == "Ok") {
                        // this.SaveImages().then((data) => {})

                        this.loadingRender = false;
                        this.$router.push({ name: "LoginPage" });
                        this.$mySweetDefaultTost(
                          "عملیات موفق",
                          "درخواست شما با موفقیت ثبت شد.",
                          "success",
                          3000,
                        );
                        this.$router.push({
                          name: "RegisterCheck",
                          params: { Status: this.IdEftetah },
                        });
                        return;
                      } else {
                        this.loadingRender = false;
                        this.$mySweetDefaultTost(
                          "عملیات ناموفق",
                          " مشکلی در بارگذاری مدارک بوجود آمده است. دوباره تلاش کنید",
                          "error",
                          4000,
                        );
                        return;
                      }
                    });
                  });
                }
                this.SendSmsRegister(this.IdEftetah);
                this.$router.push({ name: "LoginPage" });
                return;
              }
            })
            .finally(() => {});
        }
      } else {
        this.$mySweetDefaultTost(
          "عملیات ناموفق",
          " فرمت کد ملی نامعتبر میباشد ",
          "error",
          3000,
        );
        return;
      }
    },
    SendSmsRegister(coderahgiri) {
      var formdata = new FormData();

      //formdata.append('mobile', mobile)
      formdata.append("coderahgiri", coderahgiri);
      formdata.append("userInput", this.captchaText2);
      formdata.append("captchaId", this.captchaId2);
      var DataAxios_sendSMS = {
        ArryfildValue: formdata,
        Action: "EftetahHesab/SendSmsRegister",
        Method: "POST",
        Token: "",
      };
      this.$PostFormData(DataAxios_sendSMS).then((data) => {
        // console.log(data)
      });
    },
    EditOzv() {
      if (this.$requiredCodeMeli("Register")) {
        if (this.$ValidForm("Register")) {
          this.DataAxiosEdit.ArryfildValue = {
            Id: this.RegisterCheck,
            OzvName: this.OzvName,
            OzvFamily: this.OzvFamily,
            Pedar: this.Pedar,
            Shenasname: this.Shenasname,
            Email: "",
            MahalSodor: this.Sodor,
            CodeMeli: this.CodeMeli,
            Adres: this.Address,
            Tel: this.Tel,
            Mobile: this.Mobile,
            tblComboIdSex13: this.cmbSEX,
            tblComboIdTahol19: this.cmbTaahol,
            wwwtblTafsiliTypeId:
              this.Islogin == undefined
                ? this.ResultcmbcmbTafsiliType.id
                : this.ResultcmbcmbTafsiliType[0].id,
            wwwtblAzaNoeId:
              this.Islogin == undefined
                ? this.ResultcmbcmbAzaNoeArray.id
                : this.ResultcmbcmbAzaNoeArray[0].id,
            PerNo: this.PerNo,
            HesabNo: this.HesabNo + "",
            tblBankId: this.ResultcmbBank,
            wwwtblAzaIdSahebHesab:
              this.wwwtblAzaIdSahebHesab != null
                ? this.wwwtblAzaIdSahebHesab
                : 0,
            BirthDate: this.BirthDate,
          };

          if (this.$session.get("CustCode") == "860" && !this.fileinfo.name) {
            this.loadingRender = false;
            this.$mySweetDefaultTost(
              "آپلود ناموفق",
              " لطفا فایل خواسته شده را بارگذاری ، سپس دوباره اقدام به درخواست ثبت عضویت خود کنید ",
              "error",
              2000,
            );
            return;
          }

          if (
            this.$session.get("CustCode") == "932" &&
            (!this.fileinfo1.name ||
              !this.fileinfo2.name ||
              !this.fileinfo3.name)
          ) {
            this.loadingRender = false;
            // console.log((this.fileinfo1 , this.fileinfo2 ,this.fileinfo3));
            this.$mySweetDefaultTost(
              "آپلود ناموفق",
              " لطفا هر سه فایل خواسته شده را بارگذاری ، سپس دوباره اقدام به درخواست ثبت عضویت خود کنید ",
              "error",
              2000,
            );
            return;
          }
          if (
            this.$session.get("CustCode") == "953" &&
            (!this.fileinfo1.name || !this.fileinfo2.name)
          ) {
            this.loadingRender = false;
            // console.log((this.fileinfo1 , this.fileinfo2 ,this.fileinfo3));
            this.$mySweetDefaultTost(
              "آپلود ناموفق",
              " لطفا فایل تصاویر کارت ملی و شناسنامه خودرا بارگذاری ، سپس دوباره اقدام به درخواست ثبت عضویت خود کنید ",
              "error",
              2000,
            );
            return;
          }
          this.$PostData(this.DataAxiosEdit)
            .then((data) => {
              // console.log(data);
              if (data.status != "true") {
                this.loadingRender = false;
                this.$mySweetDefaultTost(
                  "عملیات ناموفق",
                  " در ویرایش مشخصات شما مشکلی پیش آمده لطفا مجدد تلاش کنید",
                  "error",
                  4000,
                );
                return;
              } else {
                this.loadingRender = false;
                this.$mySweetDefaultTost(
                  "عملیات موفق",
                  "درخواست شما با موفقیت ثبت شد.",
                  "success",
                  5000,
                );
              }
              if (
                this.$session.get("CustCode") == "932" &&
                (this.fileinfo1.name ||
                  this.fileinfo2.name ||
                  this.fileinfo3.name)
              ) {
                this.loadingRender = false;

                if (this.fileinfo1Isedit) {
                  var formdata1 = new FormData();
                  formdata1.append("Image", this.fileinfo1);
                  formdata1.append("IdEftetah", this.RegisterCheck);
                  formdata1.append("wwwtblcomboidgrp328", 181070514);
                  this.DataAxiosUpload.ArryfildValue = formdata1;
                  this.DataAxiosUpload.Action =
                    "EftetahHesab/EditUploadAtachment";
                  this.$PostFormData(this.DataAxiosUpload).then((data) => {});
                }
                if (this.fileinfo2Isedit) {
                  var formdata2 = new FormData();
                  formdata2.append("Image", this.fileinfo2);
                  formdata2.append("IdEftetah", this.RegisterCheck);
                  formdata2.append("wwwtblcomboidgrp328", 181070505);
                  this.DataAxiosUpload.ArryfildValue = formdata2;
                  this.DataAxiosUpload.Action =
                    "EftetahHesab/EditUploadAtachment";
                  this.$PostFormData(this.DataAxiosUpload).then((data) => {});
                }
                if (this.fileinfo3Isedit) {
                  var formdata3 = new FormData();
                  formdata3.append("Image", this.fileinfo3);
                  formdata3.append("IdEftetah", this.RegisterCheck);
                  formdata3.append("wwwtblcomboidgrp328", 181070516);
                  this.DataAxiosUpload.ArryfildValue = formdata3;
                  this.DataAxiosUpload.Action =
                    "EftetahHesab/EditUploadAtachment";
                  this.$PostFormData(this.DataAxiosUpload).then((data) => {});
                }
              }
              if (
                this.$session.get("CustCode") == "953" &&
                (this.fileinfo1.name || this.fileinfo2.name)
              ) {
                this.loadingRender = false;

                if (this.fileinfo1Isedit) {
                  var formdata1 = new FormData();
                  formdata1.append("Image", this.fileinfo1);
                  formdata1.append("IdEftetah", this.RegisterCheck);
                  formdata1.append("wwwtblcomboidgrp328", 181070514);
                  this.DataAxiosUpload.ArryfildValue = formdata1;
                  this.DataAxiosUpload.Action =
                    "EftetahHesab/EditUploadAtachment";
                  this.$PostFormData(this.DataAxiosUpload).then((data) => {});
                }
                if (this.fileinfo2Isedit) {
                  var formdata2 = new FormData();
                  formdata2.append("Image", this.fileinfo2);
                  formdata2.append("IdEftetah", this.RegisterCheck);
                  formdata2.append("wwwtblcomboidgrp328", 181070505);
                  this.DataAxiosUpload.ArryfildValue = formdata2;
                  this.DataAxiosUpload.Action =
                    "EftetahHesab/EditUploadAtachment";
                  this.$PostFormData(this.DataAxiosUpload).then((data) => {});
                }
                if (this.fileinfo3Isedit) {
                  var formdata3 = new FormData();
                  formdata3.append("Image", this.fileinfo3);
                  formdata3.append("IdEftetah", this.RegisterCheck);
                  formdata3.append("wwwtblcomboidgrp328", 181070516);
                  this.DataAxiosUpload.ArryfildValue = formdata3;
                  this.DataAxiosUpload.Action =
                    "EftetahHesab/EditUploadAtachment";
                  this.$PostFormData(this.DataAxiosUpload).then((data) => {});
                }
              }
            })
            .finally(() => {
              this.loadingRender = false;
              this.$router.push({ name: "LoginPage" });
              this.$mySweetDefaultTost(
                "عملیات موفق",
                "درخواست شما با موفقیت ویرایش شد.",
                "success",
                3000,
              );
              return;
            });
        }
      }
    },
    changeRdo() {
      if (this.rdoAsli) {
        this.rdoAsli = false;
        this.IsVabaste = true;
      } else {
        if (!this.rdoAsli) {
          this.rdoAsli = true;
          this.IsVabaste = false;

          this.CodeMeliVabaste = "";
          this.Moshakhasat = "";
        }
      }
    },
    CheckCodemeli() {
      var formdata = new FormData();
      formdata.append("Codemeli", this.CodeMeliVabaste);
      var DataAxiosGetuser = {
        ArryfildValue: formdata,
        Method: "Post",
        Action: "getCodeMeli",
        Token: "",
      };
      this.$PostFormData(DataAxiosGetuser).then((data) => {
        if (data.status == "OK") {
          this.Moshakhasat = data.data;
          this.wwwtblAzaIdSahebHesab = data.id;
          this.$mySweetDefaultTost(
            "عملیات موفق",
            "  کد ملی معتبر می‌باشد ",
            "success",
            1000,
          );
        } else {
          this.wwwtblAzaIdSahebHesab = 0;
          this.$mySweetDefaultTost(
            "عملیات ناموفق",
            "  کد ملی نامعتبر می‌باشد ",
            "error",
            3000,
          );
        }
      });
    },
    clickUploader(fileIndex) {
      document.getElementById("Uploader" + fileIndex).click();
    },
    setFile(data) {
      // console.log(data[0]);
      for (let index = 0; index < data.length; index++) {
        const fileInput = null;
        if (index == 0) {
          fileInput = document.getElementById("Uploader1");
        }
        if (index == 1) {
          fileInput = document.getElementById("Uploader2");
        }
        if (index == 2) {
          fileInput = document.getElementById("Uploader3");
        }
        // console.log(fileInput);
        const content = data[index].binary;
        const blob = new Blob([content], { type: "image/png" });
        const fileAdd = new File([blob], data[index].filename);
        const fileList = new DataTransfer();
        fileList.items.add(fileAdd);
        fileInput.files = fileList.files;

        if (index == 0) {
          // console.log(fileList.files[0]);
          this.fileinfo1 = fileList.files[0];
        }
        if (index == 1) {
          // console.log(fileList.files[0]);
          this.fileinfo2 = fileList.files[0];
        }
        if (index == 2) {
          // console.log(fileList.files[0]);
          this.fileinfo3 = fileList.files[0];
        }
      }
    },
    changefile(fileIndex, e) {
      const file = e.target.files[0];
      if (!file) return;

      const allowedExtensions = [
        "gif",
        "jpg",
        "jpeg",
        "png",
        "zip",
        "rar",
        "pdf",
      ];

      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        this.$mySweetDefaultTost(
          "فرمت فایل مجاز نیست",
          `فرمت ${fileExtension} پشتیبانی نمی‌شود.`,
          "error",
          3000,
        );
        e.target.value = "";
        return;
      }

      // fileIndex is Customer 932 (Bime Tamin Ejtemai)
      if (fileIndex && fileIndex > 0) {
        if (fileIndex == 1) {
          if (
            document.getElementById("Uploader1").files[0].size >
            1024 * 1024 * 5
          ) {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "  حجم فایل تصویر کارت ملی بیشتر از 5 مگابایت است ",
              "error",
              3000,
            );
            return;
          } else {
            // console.log(document.getElementById('Uploader1').files[0]);
            this.fileinfo1 = document.getElementById("Uploader1").files[0];
            this.fileinfo1Isedit = true;
          }
        }
        if (fileIndex == 2) {
          if (
            document.getElementById("Uploader2").files[0].size >
            1024 * 1024 * 5
          ) {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "  حجم فایل تصویر صفحه اول شناسنامه بیشتر از 5 مگابایت است ",
              "error",
              3000,
            );
            return;
          } else {
            this.fileinfo2 = document.getElementById("Uploader2").files[0];
            this.fileinfo2Isedit = true;
          }
        }
        if (fileIndex == 3) {
          if (
            document.getElementById("Uploader3").files[0].size >
            1024 * 1024 * 5
          ) {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "  حجم فایل حکم کارگزینی/مستمری/بازماندگی بیشتر از 5 مگابایت است ",
              "error",
              3000,
            );
            return;
          } else {
            this.fileinfo3 = document.getElementById("Uploader3").files[0];
            this.fileinfo3Isedit = true;
          }
        }
      } else {
        if (
          document.getElementById("Uploader").files[0].size >
          1024 * 1024 * 5
        ) {
          this.$mySweetDefaultTost(
            "عملیات ناموفق",
            "  حجم فایل مورد نظر بیشتر از 5 مگابایت است ",
            "error",
            3000,
          );
          return;
        } else {
          this.fileinfo = document.getElementById("Uploader").files[0];
        }
      }
    },
    validateSelection(data) {
      this.ResultcmbcmbAzaNoeArray = data.id;
    },
    validateSelectionShobe(data) {
      this.ResultcmbcmbTafsiliType = data.id;
      if (this.$session.get("CustCode") != "932") this.GetTafsiliType();
    },
    validateSelectionOstan(data) {
      this.ResultcmbGrp325 = data.id;
      this.GetTafsiliType();
    },
    validateSelectionJob(data) {
      if (data.id != undefined) {
        this.wwwtblJobId = data.id;
      }
    },
    GetcmbGrp325() {
      var dataAxsiosCmb = {
        ArryfildValue: "",
        Method: "post",
        Action: "VaziatCombo",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("num", 325);
      dataAxsiosCmb.ArryfildValue = formData;
      this.$PostFormData(dataAxsiosCmb).then((datacmb) => {
        datacmb.forEach((element) => {
          let option = {
            name: element.name,
            id: element.id,
          };
          this.OptionsvalidateSelection3.push(option);
        });

        // console.log(datacmb);
      });
    },
    GetTafsiliType() {
      if (
        this.ResultcmbcmbTafsiliType != null &&
        this.ResultcmbcmbTafsiliType != undefined
      ) {
        this.loadingRender = true;
        var formdata = new FormData();
        formdata.append(
          "BnpId",
          this.ResultcmbcmbTafsiliType.bnpCashDbtblTafsiliTypeId,
        );
        formdata.append("custcode", this.$session.get("CustCode"));
        var DataAxios_TafsiliType = {
          ArryfildValue: formdata,
          Method: "Post",
          Action: "AzaNoe/GetIndex",
          Token: "",
        };
        this.$PostFormData(DataAxios_TafsiliType)
          .then((data) => {
            this.ListModelAzaNoe = data;
            this.OptionsvalidateSelection = [];
            for (let index = 0; index < this.ListModelAzaNoe.length; index++) {
              const element = this.ListModelAzaNoe[index];
              if (this.$session.get("CustCode") == "932") {
                if (element.tblComboId325Ostan == this.ResultcmbGrp325) {
                  var option = {
                    name: element.nameHoze,
                    id: element,
                  };
                  this.OptionsvalidateSelection.push(option);
                }
              } else if (this.$session.get("CustCode") == "948") {
                if (
                  element.bnpCashDbtblAzaNoeId == 15 ||
                  element.bnpCashDbtblAzaNoeId == 17 ||
                  element.bnpCashDbtblAzaNoeId == 32036183
                ) {
                  var option = {
                    name: element.nameHoze,
                    id: element,
                  };
                  this.OptionsvalidateSelection.push(option);
                }
              } else {
                var option = {
                  name: element.nameHoze,
                  id: element,
                };
                this.OptionsvalidateSelection.push(option);
              }
            }
          })
          .finally(() => {
            this.loadingRender = false;
          });
      }
    },
    GetDataRegister() {
      this.GetDataJobs();

      this.loadingRender = false;
      // document.getElementsByName('zipcode')[0].classList.add('form-control')
      // document.getElementsByName('zipcode')[0].setAttribute('autocomplete', 'new-password')
      // document.getElementsByName('TafsiliType')[0].classList.add('form-control')
      // document.getElementsByName('TafsiliType')[0].setAttribute('autocomplete', 'new-password')

      this.loadingRender = false;
    },
    GetDataJobs() {
      var dataAxsiosJobs = {
        ArryfildValue: "",
        Method: "post",
        Action: "VaziatCombo/GetJobs",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostData(dataAxsiosJobs).then((res) => {
        res.forEach((element) => {
          let option = {
            name: element.jobName,
            id: element.id,
          };
          this.OptionsvalidateSelection4.push(option);
        });
      });
    },
  },
  // computed:{
  //     uploaderDiv(){
  //         if (document.getElementById('Uploader').files.length>0) {
  //             return "FullDiv"
  //         }else
  //         {
  //             return "EmptyDiv"
  //         }
  //     }
  // }
  /*mounted() {
    console.log(this.$session.get("CustCode"));
  },*/
};
</script>
<style scoped>
pre {
  font-size: 1.2em !important;
  font-family: IRANSansWeb !important;
}
.EmptyDiv {
  width: 100%;
  min-height: 80px;
  background: rgb(184, 218, 235);
  border: 2px dotted #3161e7;
  border-radius: 15px;
}

.FullDiv {
  width: 100%;
  min-height: 80px;
  background: rgb(184, 235, 205);
  border: 2px dotted #12852f;
  border-radius: 15px;
}

.btn-submit {
  color: blanchedalmond !important;
  background: linear-gradient(
    301deg,
    rgba(145, 124, 193, 1) 0%,
    rgba(72, 20, 193, 1) 100%
  );
  /* background: linear-gradient(301deg, rgba(145, 124, 193, 1) 0%,#403c47 100%); */
}

.btn-submit:hover {
  color: blueviolet !important;
  background: #f8f9fa;
  border: solid 3px rgba(72, 20, 193, 1);
}
.titleHr {
  float: right;
  transition: 0.3s;
  border-bottom: 2px solid #ff9800 !important;
  width: 30%;
  min-width: 200px;
  margin: 0;
  border-radius: 10px;
}
</style>

